import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { AuthService } from '../providers/auth.service';
import { SidebarService } from '../providers/sidebar.service';
import { CommonModule } from '@angular/common';
import { DbService } from '../providers/db.service';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CategoryInterface, SubCategoryInterface } from '../interfaces';

@Component({
  selector: 'app-categories',
  standalone: true,
  imports: [TranslocoDirective, CommonModule, FormsModule],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.css',
  encapsulation: ViewEncapsulation.None
})
export class CategoriesComponent implements OnInit {

  catsArray: CategoryInterface[] = [];
  subCatsArray: SubCategoryInterface[] = [];
  selectedCategory = -1;
  selectedSubCategory = -1;
  maxNumberOfCategories = 8;
  maxNumberOfSubcategories = 4;
  categoryModel = {
    name: '',
    label: ''
  };
  subCategoryModel = {
    name: ''
  };
  showSpinner = true;

  sideBarSize = '';
  public db = inject(DbService);
  public auth = inject(AuthService);
  private translocoService = inject(TranslocoService);
  private toastr = inject(ToastrService);
  public sb = inject(SidebarService);


  ngOnInit(): void {
    this.ngOnInitAsync()
  }

  async ngOnInitAsync() {
    try {
      await this.listOfAllCats(this.auth.currentUserIDSig()?.uid);
      this.sideBarSize = this.sb.currentSidebarSize();
      this.showSpinner = false;
    } catch (err) {
      console.log(err.code)
    }
  }

  async listOfAllCats(userUID: string): Promise<void> {
    try {
      this.catsArray = await this.db.getCatsAsync(userUID);
    } catch (err) {
      console.error('Error while fetching categories:', err);
    }
  }

  async listOfSubCats(catID: string, userUID: string): Promise<void> {
    try {
      this.subCatsArray = await this.db.getSubCatListAsync(catID, userUID);
    } catch (err) {
      console.error('Error while fetching subcategories:', err);
    }
  }

  async deleteCategory(docID: string, userUID: string): Promise<void> {
    try {
      await this.db.deleteCategoryAsync(docID, userUID);
      this.showToast('success', `${this.translocoService.translate('toasts.categoriesSccessMessageDelCat', undefined, this.auth.currentUserSig()?.lang)}`)
      this.listOfAllCats(userUID);
    } catch (err) {
      console.log(err.code)
      this.showToast('error', `${this.translocoService.translate('toasts.categoriesFailMessageDelCat', undefined, this.auth.currentUserSig()?.lang)}`)
    }
  }

  async addCategory(userUID: string): Promise<void> {
    try {
      await this.db.createCategoryAsync(this.categoryModel, userUID);
      this.showToast('success', `${this.translocoService.translate('toasts.categoriesSuccessMessageAddCat', undefined, this.auth.currentUserSig()?.lang)}`)
      this.listOfAllCats(userUID);
    } catch (err) {
      this.showToast('error', `${this.translocoService.translate('toasts.categoriesFailMessageAddCat', undefined, this.auth.currentUserSig()?.lang)}`)
    }
  }

  async renameCategory(model: { label: string; name: string; }, docID: string, userUID: string): Promise<void> {
    try {
      await this.db.renameCategoryAsync(model, docID, userUID);
      this.showToast('success', `${this.translocoService.translate('toasts.categoriesSuccessMessageRenameCat', undefined, this.auth.currentUserSig()?.lang)}`)
      this.listOfAllCats(userUID);
    } catch (err) {
      console.log(err.code)
      this.showToast('error', `${this.translocoService.translate('toasts.categoriesFailMessageRenameCat', undefined, this.auth.currentUserSig()?.lang)}`)
    }
  }

  async addSubCategory(model: { name: string; }, catID: string, userUID: string): Promise<void> {
    try {
      await this.db.createSubCategoryAsync(model, catID, userUID);
      this.showToast('success', `${this.translocoService.translate('toasts.categoriesSuccessMessageAddSubCat', undefined, this.auth.currentUserSig()?.lang)}`);
    } catch (err) {
      console.log(err.code)
      this.showToast('error', `${this.translocoService.translate('toasts.categoriesFailMessageAddSubCat', undefined, this.auth.currentUserSig()?.lang)}`)
    }
  }

  async renameSubCategory(model: { name: string; }, catID: string, subCatID: string, userUID: string): Promise<void> {
    try {
      await this.db.renameSubCategoryAsync(model, catID, subCatID, userUID);
      this.showToast('success', `${this.translocoService.translate('toasts.categoriesSuccessMessageRenameSubCat', undefined, this.auth.currentUserSig()?.lang)}`)
    } catch (err) {
      console.log(err.code)
      this.showToast('error', `${this.translocoService.translate('toasts.categoriesFailMessageRenameSubCat', undefined, this.auth.currentUserSig()?.lang)}`)
    }
  }

  async deleteSubCategory(catID: string, subCatID: string, userUID: string): Promise<void> {
    try {
      await this.db.deleteSubCategoryAsync(catID, subCatID, userUID);
      this.showToast('success', `${this.translocoService.translate('toasts.categoriesSuccessMessageDelSubCat', undefined, this.auth.currentUserSig()?.lang)}`)
    } catch (err) {
      console.log(err.code)
      this.showToast('error', `${this.translocoService.translate('toasts.categoriesFailMessageDelSubCat', undefined, this.auth.currentUserSig()?.lang)}`)
    }
  }

  showToast(toastType: string, title: string, content?: string) {
    const varTimeOut = 5000;
    const varProgressBar = true;
    const varPositionClass = 'toast-top-center';
    if (toastType === 'success') {
      this.toastr.success(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else if (toastType === 'info') {
      this.toastr.info(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    } else {
      this.toastr.error(content, title, {
        timeOut: varTimeOut,
        progressBar: varProgressBar,
        positionClass: varPositionClass
      });
    }
  }
}
